import type * as Brink from 'types/vendors/brink'
import { normalizeBrinkPrice } from '~/lib/brink'

export function normalizePriceDiscount(cart: Brink.Cart, currencyCode: Environment.Currency['code']): number {
  const discount = normalizeBrinkPrice(cart.totalDiscountAmount, currencyCode)

  return discount
}
